import React from 'react';
import Routes from './routes';

import './styles/global.css';
import 'leaflet/dist/leaflet.css';

function App() {
  return (
    <Routes />
  );
}

export default App;
